export const actions = {
	showMessage(message) {
		return {type: 'SHOW_MESSAGE', payload: message};
	},

	hideMessage() {
		return {type: 'HIDE_MESSAGE'};
	},
	
	runHidingMessage() {
		return function(dispatch) {
			setTimeout(() => {
				dispatch(actions.showMessage('')); // Ставлю сообщение в виде пустой строки, чтобы в состоянии не маячило, это можно и не делать.
				dispatch(actions.hideMessage());
			}, 3000);
		}
	},

	saveUserAnswer(questionIndex, userAnswer) {
		return {type: 'SAVE_USER_ANSWER', payload: {questionIndex: questionIndex, userAnswer: userAnswer}};
	},
	
	addQuestions(arr) {
		return {type: 'ADD_QUESTIONS', payload: arr};
	},

}